// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__3j-dI","text":"Divider_text__1rtkj"};